import React from "react";
import "./MovePaperWorkEstimate.scss"
import { MovePaperWorkCard } from "components/movePaperWorkCard";
import { MoveListCard } from "components/moveListCard";
import { Button } from "components/button";
import { EstimatorDetailCard } from "components/estimatorDetailCard";
import { CompanyDetailCard } from "components/companyDetailCard";
import { InfoCard } from "components/infoCard";
import { CardLayout } from "components/cardLayout";
import { getEstFlowEstimateDetails, getEstimatorInventory } from "../../core/services/moveDetailsByCustomer"
import { getCustomerDetails } from 'core/services/getCustomerDetailsService'
//@ts-ignore
// import SimpleLineIcon from 'react-simple-line-icons';
// import '../../../node_modules/font-awesome/css/font-awesome.min.css'
import { MdClose } from "react-icons/md";
//@ts-ignore
import SignatureCanvas from 'react-signature-canvas'
import { FormGroup, Validators, FormBuilder, FormControl } from "react-reactive-form";
import { client } from "App";
import { saveSignatures } from '../../core/services/saveSignatures'
import { navigate } from "@reach/router";
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import Spinner from '../spinner/spinner';
//import { sign } from "crypto";
const transportData11 = [
    { type: 'Loading', summary: '1 Truck, 3 Movers', amount: '$522', hour: '3 HRS x $183 ' },
    { type: 'Unloading', summary: '1 Truck, 3 Movers', amount: '$378', hour: '3 HRS x $183 ' },
    { type: 'Travel', summary: '', amount: '$183', hour: ' ' },
    { type: 'Fuel', summary: '', amount: '$25', hour: '' },
    { type: 'Materials', summary: '', amount: '$106', hour: '' },
]
const bedroom1Data = [
    { type: '1.5 Carton', summary: '(PBO)', amount: '3', hour: '' },
    { type: '3.0 Carton', summary: '(PBO)', amount: '3', hour: '' },
    { type: 'Dresser ', summary: 'Triple', amount: '1', hour: ' ' },
    { type: 'Bed', summary: 'Queen', amount: '1', hour: '' },
    { type: 'Nightstand', summary: '', amount: '2', hour: '' },
]

export interface MovePaperWorkEstimateProps {
    onClick?(): void;
    formGroup?: FormGroup;
    formControl?: FormControl;
    formPage: any
    // bed1Data?:any[];
}

export interface MovePaperWorkEstimateState {
    transportData: any;
    responseEstDetail: any,
    inventoryData: any,
    inventoryUniqueRow: any,
    trimmedDataURFirst: any,
    trimmedDataURSecond: any,
    btnText: any
    base64FistSign: any,
    base64SecondSign: any,
    isValid: boolean;
    Customer: any;
    loading: boolean;
    updateSign: boolean
}
var signs = [
    { id: "1", sign: "" },
    { id: "2", sign: "" }
];

class MovePaperWorkEstimate extends React.Component<MovePaperWorkEstimateProps, MovePaperWorkEstimateState> {
    private _isMounted: boolean = false
    sigCanvasFirst: any;
    sigCanvasSecond: any;
    firstSignPadRef: any;

    constructor(props: MovePaperWorkEstimateProps) {
        super(props);
        //debugger;
        this.state = {
            transportData: [],
            responseEstDetail: {},
            inventoryData: [],
            inventoryUniqueRow: [],
            trimmedDataURFirst: "",
            trimmedDataURSecond: "",
            btnText: "Book Now",
            base64FistSign: "",
            base64SecondSign: "",
            isValid: false,
            Customer: JSON.parse(localStorage.getItem("customerDetails") || '{}'),
            loading: true,
            updateSign: false
        };

        //localStorage.removeItem("signs");
        localStorage.setItem("signs", JSON.stringify([
            { id: "1", sign: "" },
            { id: "2", sign: "" }
        ]));
        // if(localStorage.getItem("signs")){

        //     //signs=JSON.parse(localStorage.getItem("signs") ||"{}");
        //     localStorage.setItem("signs",JSON.stringify(signs));
        // }else{
        //     localStorage.setItem("signs",JSON.stringify(signs));
        // }
        console.log("constructor")
    }


    save(flag: any) {
        if (this.isSignedBoth() == true) {
            // var params={
            //     customerID:  "6980504",
            //     moveID:  "6882423",
            //     moveDailySheetID:   "6655281",
            //     estimatorID:   "1220",
            //     signature1: "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",
            //     signature2: ""
            // }

            var params = {
                customerID: this.state.Customer.customerID,
                moveID: this.state.Customer.moveID,
                moveDailySheetID: this.state.Customer.moveDailySheetID,
                estimatorID: this.state.Customer.estimatorID,
                signature1: this.sigCanvasFirst.toDataURL('image/png').replace('data:image/png;base64,', ''),
                signature2: this.sigCanvasSecond.toDataURL('image/png').replace('data:image/png;base64,', '')
            }
            this.saveSignatures(params)
                .then(response => {
                    console.log(JSON.stringify(response));
                    if (response.data.saveSignatures[0].responseCode.length > 0) {
                        console.log("Signatures are saved.");
                        //navigate("/move?question=deposit");
                        if (flag == "0") {
                            if (this.props.onClick) {
                                this.props.onClick();
                            }
                        } else {
                            navigate("/affirm");
                        }
                    } else {
                        console.log("Signatures are not saved.");
                    }
                });
        }
    }

    writeSignToCanvas() {
        if (signs) {
            if (signs[0].sign != "" && this.sigCanvasFirst) {
                this.sigCanvasFirst.fromDataURL(signs[0].sign, 'image/png');
            }
            if (signs[1].sign != "" && this.sigCanvasSecond) {
                this.sigCanvasSecond.fromDataURL(signs[1].sign, 'image/png');
            }
        }
    }
    async saveSignatures(params: any) {
        return client.query({
            query: saveSignatures, variables: {
                sigInput: {
                    "customerID": params.customerID,
                    "moveID": params.moveID,
                    "moveDailySheetID": params.moveDailySheetID,
                    "estimatorID": params.estimatorID,
                    "signature1": params.signature1,
                    "signature2": params.signature2
                }
            }
        });
    }

    componentDidMount() {

        console.log("componentDidMount")
        //this.setState({loading:false});
        this._isMounted = true;
        var cid = (localStorage.getItem("CID") || "");
        var securetoken = localStorage.getItem("securetoken") || "";
        //this.getData(cid);
        Promise.all([
            //this.getCustomerDetails(cid),
            this.getEstFlowEstimateDetails(cid),
            this.getEstimatorInventory(cid)
        ]).then((response: any[]) => {
            if (this._isMounted) {
                // let responseCustDetail = response[0][0];
                // localStorage.setItem("customerDetails", JSON.stringify(responseCustDetail));
                // var custDetails = JSON.parse(localStorage.getItem("customerDetails") || "{}");

                const responseEstDetail = response[0][0];

                this.setState({ responseEstDetail: responseEstDetail });
                //localStorage.setItem("estFlowEstimateDetails", JSON.stringify(responseEstDetail));

                var transportDataArr = [
                    { type: 'Loading', summary: responseEstDetail.loadTrucks + ' Truck, ' + responseEstDetail.loadCrewSize + ' Movers ', amount: '$' + Number((responseEstDetail.loadRate * responseEstDetail.loadEstimatedHours)).toFixed(2), hour: '' },
                    { type: 'Unloading', summary: responseEstDetail.loadTrucks + ' Truck, ' + responseEstDetail.loadCrewSize + ' Movers ', amount: '$' + Number((responseEstDetail.unloadRate * responseEstDetail.unloadEstimatedHours)).toFixed(2), hour: '' },
                    { type: 'Travel', summary: '', amount: '$' + Number((responseEstDetail.travelRate * responseEstDetail.travelHours)).toFixed(2), hour: ' ' },
                    { type: 'Fuel', summary: '', amount: '$' + responseEstDetail.fuelCharge, hour: '' },
                    { type: 'Materials', summary: '', amount: '$' + responseEstDetail.materialCost, hour: '' },
                    { type: 'Packing Cost', summary: '', amount: '$' + responseEstDetail.packingCost, hour: '' },
                    { type: 'Additional Services', summary: '', amount: '$' + responseEstDetail.additionalCharges, hour: '' },

                    // { type: 'Additional coverage and protection charges', summary: '', amount: '$' + responseEstDetail.protectionCharges, hour: '', shouldShow: responseEstDetail?.isDisplayFVP},
                    { type: 'AMS Adjustment', summary: '', amount: '$' + responseEstDetail.discountValue, hour: '' },
                    { type: 'Pass through charges', summary: '', amount: '$' + Number((parseFloat(responseEstDetail.abfVal) + parseFloat(responseEstDetail.thirdPartyService))).toFixed(2), hour: '' },

                ]

                // if (parseFloat(responseEstDetail.storageCharge) > 0) {
                //     transportDataArr.push(
                //         { type: 'Stoarge Charges', summary: '', amount: '$' + Number(parseFloat(responseEstDetail.storageCharge)).toFixed(2), hour: '' }
                //     )
                // }
                if (parseFloat(responseEstDetail.salesTaxCost) > 0) {
                    transportDataArr.push(
                        { type: 'Sales Tax', summary: '', amount: '$' + Number(parseFloat(responseEstDetail.salesTaxCost)).toFixed(2), hour: '' }
                    )
                }
                if (parseFloat(responseEstDetail?.isDisplayFVP) > 0) {
                    transportDataArr.push(
                        { type: 'Additional coverage and protection charges', summary: '', amount: '$' + responseEstDetail.protectionCharges, hour: '' },
                    )
                }
                // if (parseFloat(responseEstDetail?.junkServiceCharge) > 0) {
                //     transportDataArr.push(
                //         { type: 'Box Removal', summary: '', amount: '$' + responseEstDetail.junkServiceCharge, hour: '' },
                //     )
                // }
                if (parseFloat(responseEstDetail?.junkServiceCharge) > 0) {
                    transportDataArr.push(
                        { type: 'Junk Service', summary: '', amount: '$' + responseEstDetail.junkServiceCharge, hour: '' },
                    )
                }


                this.setState({ transportData: transportDataArr, loading: false });

                var inventory = response[1];
                this.setState({ inventoryData: inventory });
                //localStorage.setItem("estInventory", JSON.stringify(inventory));

                var inventoryUniqueNames: any = [];
                const inventoryObj = this.state.inventoryData.filter((item: { name: any; }) => {
                    var idx = inventoryUniqueNames.findIndex((x: { name: any; }) => x.name == item.name);
                    if (idx <= -1) {
                        inventoryUniqueNames.push({ name: item.name });
                    }
                });
                this.setState({ inventoryUniqueRow: inventoryUniqueNames, loading: false });

                if (this.props.formControl) {
                    this.props.formControl.setValue("0");
                }
                if (!this.props.formControl) {
                    // debugger;
                }

                // setTimeout(() => {
                //     this.writeSignToCanvas();
                //     this.setState({updateSign:true});
                // }, 100)
            }
        });
        //this.setState({loading:false});
    }

    componentWillUnmount() {
        this._isMounted = false;
        console.log("componentWillUnmount")
    }

    async getCustomerDetails(cid: string, securetoken: string) {
        return await getCustomerDetails(cid, securetoken)
    }

    async getEstFlowEstimateDetails(cid: string) {
        return await getEstFlowEstimateDetails(cid)
    }

    async getEstimatorInventory(cid: string) {
        return await getEstimatorInventory(cid)
    }

    openMoveDetail(move: any) {
        // navigate(`/moves/${move.moveID}`);
        // alert("click me")
    }
    bookMove() {
        if (this.props.onClick) {
            this.props.onClick()
        }
    }

    sumProperty(arr: any, type: any) {
        return arr.reduce((total: number, obj: any) => {
            if (typeof obj[type] === 'string') {
                return total + Number(obj[type].replace('$', ''));
                //return total + Number(obj[type]);
            }
            return total + obj[type].replace('$', '');
            //return total + obj[type];
        }, 0);
    }

    clearFirst = () => {
        // if(this.props.formControl){
        //     this.props.formControl.reset();
        // }
        this.sigCanvasFirst.clear();
        signs[0] = { id: "1", sign: "" };
        localStorage.setItem("signs", JSON.stringify(signs));
        if (this.props.formControl) {
            this.props.formControl.setValue("0")
        }
    }

    clearSecond = () => {
        // if(this.props.formControl){
        //     this.props.formControl.reset();
        // }
        this.sigCanvasSecond.clear();
        signs[1] = { id: "2", sign: "" };
        localStorage.setItem("signs", JSON.stringify(signs));
        if (this.props.formControl)
            this.props.formControl.setValue("0")
    }

    trimFirst = () => {
        this.setState({ trimmedDataURFirst: this.sigCanvasFirst.getTrimmedCanvas().toDataURL('image/png') })
    }

    trimSecond = () => {
        this.setState({ trimmedDataURSecond: this.sigCanvasSecond.getTrimmedCanvas().toDataURL('image/png') })
    }

    renderInventory() {
        const items = this.state.inventoryUniqueRow.map((item: any, index: number) => {

            var nestedData: any = [];
            var inventData = this.state.inventoryData.filter((itemObj: any) => {
                if (itemObj.name.match(item.name)) {
                    var obj = { type: itemObj.materialDescription, summary: itemObj.packingType, amount: itemObj.qTY, hour: '' }
                    nestedData.push(obj);
                    return obj;
                }
            });

            var totalQty = this.sumProperty(nestedData, 'amount');
            var totalLbs = this.sumProperty(inventData, 'cubeQTY');

            return <MoveListCard
                key={index}
                title={item.name}
                onClick={(item: any) => this.openMoveDetail(item)}
                text={"Total"}
                totalValue={totalQty + " (" + totalLbs + " lbs)"}
                data={nestedData}
            />
        })

        return items;
    }



    ValidateSigns() {

        var isAffirm = (localStorage.getItem("isAffirm") || "0");
        const { btnText } = this.state //destucture state
        if (btnText === "Book Now") {
            const element: any = document.getElementById("firstsignpad");
            if (element) {
                element.scrollIntoView({ block: 'end', behavior: 'smooth' });
                this.setState({ btnText: "Continue" });
            }
        }

        var signs = JSON.parse(localStorage.getItem("signs") || "[]");
        var signFirst = signs[0];
        var signSecond = signs[1];

        if (btnText === "Continue") {
            if (this.sigCanvasFirst.isEmpty()) {
                const element: any = document.getElementById("firstsignpad");
                if (element) {
                    element.scrollIntoView({ block: 'end', behavior: 'smooth' });
                }
                return false;
            } else {
                let element: any = document.getElementById("secondsignpad");
                if (element) {
                    element.scrollIntoView({ block: 'end', behavior: 'smooth' });
                    this.setState({ btnText: "Sign Order Of Service" });
                }
            }
        } else if (btnText === "Sign Order Of Service") {
            if (this.isSignedBoth() == true) {
                //this.goToNextPage();
                if (this.props.formControl) {
                    if (isAffirm == "1") {
                        this.props.formControl.setValue("1")
                    } else {
                        this.props.formControl.setValue("0")
                    }
                }
            } else {
                return false;
            }
        }
        return true;
    }

    isSignedBoth() {
        var signs = JSON.parse(localStorage.getItem("signs") || "[]");
        var signFirst = signs[0];
        var signSecond = signs[1];

        if (this.sigCanvasFirst.isEmpty()) {
            const element: any = document.getElementById("firstsignpad");
            if (element) {
                element.scrollIntoView({ block: 'end', behavior: 'smooth' });
            }
            return false;
        } else if (this.sigCanvasSecond.isEmpty()) {
            const element: any = document.getElementById("secondsignpad");
            if (element) {
                element.scrollIntoView({ block: 'end', behavior: 'smooth' });
            }
            return false;
        }
        return true;
    }


    onSignFirst() {
        signs = JSON.parse(localStorage.getItem("signs") || "[]");
        signs[0] = { id: "1", sign: this.sigCanvasFirst.toDataURL('image/png').replace('data:image/png;base64,', '') };
        localStorage.setItem("signs", JSON.stringify(signs));

        //1-affirm, 0=normal, 2=signfirst, 3=secondsign
        if (this.props.formControl) {
            this.props.formControl.setValue("2")
        }
    }

    onSignSecond() {
        signs = JSON.parse(localStorage.getItem("signs") || "[]");
        signs[1] = { id: "2", sign: this.sigCanvasSecond.toDataURL('image/png').replace('data:image/png;base64,', '') };
        localStorage.setItem("signs", JSON.stringify(signs));

        if (this.props.formControl)
            this.props.formControl.setValue("3")
    }

    skipFroNow = () => {
        if (this.props.onClick) {
            this.props.onClick();
        }
    }
    letsBegin() {
        this.setState({ btnText: "Let's Begin" });
        this.save("1");
    }

    showHideFooter() {
        var isAffirm = (localStorage.getItem("isAffirm") || "0");
        if (this.props.formControl) {
            if (isAffirm == "1") {
                this.props.formControl.setValue("1")
            } else {
                this.props.formControl.setValue("0")
            }
        }
    }

    getEstimateTypeContent(flag: string) {
        if (flag === "Binding") {
            return `For the household goods and services identified on the estimate and that the charges shown are the charges that will be assessed for the services identified in the estimate. Additional items and services outside scope of estimate will result in additional costs and an addendum for additional services requested or revised estimate.`;
        } else if (flag === "Non Binding") {
            return `Final charges will be based on actual hourly labor, travel, materials, and/or services performed. This proposal is complete without the number of hours necessary to perform the transportation and related services as it’s based on an hourly rate. Additional 
            items and services requested will result in additional costs and an addendum for additional services requested or revised estimate.`
        } else if (flag === "Not to exceed") {
            return `Your estimate will not exceed the price listed under your estimate total and is based on current articles and or services listed or defined in this estimate. The final total will be based on actual time and services performed. Final total can be less than but not exceed the total Not to Exceed amount listed. 
            Additional Services Requested (Services not defined in original signed estimate): In the event additional services are requested or required prior to move, a new estimate will be necessary.
             If additional services are requested or required during your move, an addendum for additional services will be necessary. In either of the two circumstances the price of these services must be defined and new price defined and signed before services are performed. This estimate is valid for 60 days from the date or receipt`
        }
    }
    render() {
        console.log("render")
        var isAffirm = (localStorage.getItem("isAffirm") || "0");
        clearAllBodyScrollLocks();

        return (
            this.state.loading ? <Spinner /> :
                <div>
                    <div className="movepaper-container">
                        <div className="container relative">
                            <div className="movepaper-title move-title-updated">
                                <h1>Estimate Details</h1>
                            </div>
                            <MovePaperWorkCard />
                            <MoveListCard
                                title={"Local Transportation & Labor"}
                                onClick={(item: any) => this.openMoveDetail(item)}
                                text={"Total"}
                                // totalValue={'$' + this.sumProperty(this.state.transportData, 'amount')}
                                // totalValue={'$' + (this.state.responseEstDetail.totalCharges|| "0")}
                                totalValue={'$' + (this.state.responseEstDetail.totalChargesAfterDisc || "0")}
                                data={this.state.transportData.filter((item: any) => item.amount !== "$0.00")}
                            />
                            {/* <TextField
                                keyboardType={"text"}
                                label={"Name"}
                                formControl={this.formGroup.get('name') as FormControl}
                                variantType={"outlined"}
                            />
                             */}
                            <EstimatorDetailCard />
                            <CompanyDetailCard />
                            <InfoCard
                                valuationText={"Valuation: " + this.state.responseEstDetail.optionType}
                                estimateText={"Estimate Type: " + this.state.responseEstDetail.estimatetype}
                                title1={"Standard Valuation"}
                                content1={`If any article is lost, destroyed, or damaged while in the mover's custody, the mover's liability is limited to SIXTY CENTS($ 0.60) per pound per article, based on the actual weight of the lost, destroyed, or damaged article. This is the mover’s standard level of valuation and is provided at no charge with no deductible.`}
                                title2={this.state.responseEstDetail.estimatetype + " Estimate"}
                                content2={this.getEstimateTypeContent(this.state.responseEstDetail.estimatetype)}
                            />
                            <div className="detail-note">
                                <p>I accept the above estimate by {this.state.Customer.origin}. I understand that by accepting this estimate, I am entering into a contract with AMS to perform the work described in the estimate. This is an estimate only. Actual charges will be based upon services provided.</p>
                            </div>
                            <div className="detail-note">
                                <p><span>THE SHIPPER (OR HIS REPRESENTATIVE) BY HIS SIGNATURE HEREBY ORDERS THE SERVICES OUT-LINED HEREIN TO BE PERFORMED ON HIS BEHALF; AND FURTHER ACKNOWLEDGES THAT ALL ARRANGEMENTS REGARDING CONTACT WHILE EN ROUTE AND/OR AT DESTINATION, METHOD OF PAYMENT, AND NOTIFICATION OF CHARGES ARE AS DESIGNATED BY HIM.</span></p>
                            </div>

                            {this.renderInventory()}

                            <div className="detail-note">
                                <p>THE CARRIER, BY SIGNATURE OF ITS REPRESENTATIVE, HEREBY ACCEPTS THIS ORDER FOR SERVICES AND AGREES TO PERFORM THE SERVICES OUTLINED HEREIN AND TO COMPLY WITH SUCH OTHER ARRANGEMENTS AS ARE SPECIFIED</p>
                            </div>
                            <div className="detail-note">
                                <p><span>THE SHIPPER (OR HIS REPRESENTATIVE) BY HIS SIGNATURE HEREBY ORDERS THE SERVICES OUT-LINED HEREIN TO BE PERFORMED ON HIS BEHALF; AND FURTHER ACKNOWLEDGES THAT ALL ARRANGEMENTS REGARDING CONTACT WHILE EN ROUTE AND/OR AT DESTINATION, METHOD OF PAYMENT, AND NOTIFICATION OF CHARGES ARE AS DESIGNATED BY HIM.</span> </p>
                            </div>

                            <CardLayout style={{ padding: "2em" }}>
                                <div className="sign-detail" id="estimate-sign">
                                    <div className="sign-text">
                                        <p>Sign Here</p>
                                        <div className="sign-icon">
                                            <MdClose onClick={this.clearFirst} />
                                        </div>
                                    </div>
                                    {/* fromDataURL(base64String, options) */}
                                    <SignatureCanvas penColor='black'
                                        onEnd={() => this.onSignFirst()}
                                        ref={(ref: any) => this.sigCanvasFirst = ref}
                                        canvasProps={{ width: 500, height: 100, className: 'sigCanvas', id: 'sign-estimate-canvas' }} />
                                    <div className="signature-line"></div>
                                </div>
                            </CardLayout>
                            <div id="firstsignpad" className="confirm-btn">
                            </div>
                            <div className="movepaper-title">
                                <h1>Estimate Details</h1>
                            </div>
                            <MovePaperWorkCard />
                            <MoveListCard
                                title={"Local Transportation & Labor"}
                                onClick={(item: any) => this.openMoveDetail(item)}
                                text={"Total"}
                                // totalValue={'$' + this.sumProperty(this.state.transportData, 'amount')}
                                // totalValue={'$' + (this.state.responseEstDetail.totalCharges|| "0")}
                                totalValue={'$' + (this.state.responseEstDetail.totalChargesAfterDisc || "0")}
                                data={this.state.transportData}
                            />
                            <EstimatorDetailCard />
                            <CompanyDetailCard />
                            <InfoCard
                                valuationText={"Valuation: " + this.state.responseEstDetail.optionType}
                                estimateText={"Estimate Type: " + this.state.responseEstDetail.estimatetype}
                                title1={"Standard Valuation"}
                                content1={`If any article is lost, destroyed, or damaged while in the mover's custody, the mover's liability is limited to SIXTY CENTS($ 0.60) per pound per article, based on the actual weight of the lost, destroyed, or damaged article. This is the mover’s standard level of valuation and is provided at no charge with no deductible.`}
                                title2={this.state.responseEstDetail.estimatetype + " Estimate"}
                                content2={this.getEstimateTypeContent(this.state.responseEstDetail.estimatetype)}
                            />
                            {/* <InfoCard
                    valuationText={"Valuation: " + this.state.responseEstDetail.optionType}
                    estimateText={"Estimate Type: " + this.state.responseEstDetail.estimatetype}
                    title1={"Non-Binding Estimate"}
                    content1={`Final charges will be based on actual hourly labor, travel, materials, and/or services performed. This proposal is complete without the number of hours necessary to perform the transportation and related services as it’s based on an hourly rate. Additional 
                    items and services requested will result in additional costs and an addendum for additional services requested or revised estimate.`}
                    title2={"Not to Exceed Estimate"}
                    content2={this.getEstimateTypeContent(this.state.responseEstDetail.estimatetype)}
                /> */}

                            {this.renderInventory()}

                            <div className="detail-note">
                                <p>THE CARRIER, BY SIGNATURE OF ITS REPRESENTATIVE, HEREBY ACCEPTS THIS ORDERFOR SERVICES AND AGREES TO PERFORM THE SERVICES OUTLINED HEREIN AND TOCOMPLY WITH SUCH OTHER ARRANGEMENTS AS ARE SPECIFIED</p>
                            </div>
                            <div className="detail-note">
                                <p><span> THE SHIPPER (OR HIS REPRESENTATIVE) BY HIS SIGNATURE HEREBY ORDERSTHE SERVICES OUT-LINED HEREIN TO BE PERFORMED ON HIS BEHALF; ANDFURTHER ACKNOW LEDGES THAT ALL ARRANGEMENTS REGARDING CONTACTW HILE EN ROUTE AND/OR AT DESTINATION, METHOD OF PAYMENT, ANDNOTIFICATION OF CHARGES ARE AS DESIGNATED BY HIM.</span></p>
                            </div>
                            <CardLayout style={{ padding: "2em" }} >
                                <div className="sign-detail" id="order-sign">
                                    <div className="sign-text">
                                        <p>Sign Here</p>
                                        <div className="sign-icon">
                                            <MdClose onClick={this.clearSecond} />
                                        </div>
                                    </div>
                                    <SignatureCanvas penColor='black'
                                        onEnd={() => this.onSignSecond()}
                                        ref={(ref: any) => this.sigCanvasSecond = ref}
                                        canvasProps={{ width: 500, height: 100, className: 'sigCanvas', id: 'sign-order-canvas' }} />
                                    <div className="signature-line"></div>
                                </div>
                            </CardLayout>
                            <div id="secondsignpad" className="confirm-btn">
                            </div>


                        </div>



                        {/* {
                    (isAffirm=="1")?
                        <div className="btn-container" id="affirmbuttons">
                            <Button text="Let's Begin"
                                backgroundColor={"#4E9CE6"}
                                color={"#ffffff"}
                                onClick={() => this.letsBegin()}
                            />
                            <Button text="Skip For Now"
                                backgroundColor={"#ffffff"}
                                marginTop={"0em"}
                                border={"3px solid #4E9CE6"}
                                color={"#4E9CE6"}
                                style={{}}
                                onClick={() => this.skipFroNow()}
                            />

                        </div>
                    : null
                } */}



                    </div>

                    {/* <div className="bookmove-btn btn_fixed">
                         <Button
                             text={"Save Signature"}
                         />
                     </div> */}
                </div>
        );
    }
}

export default MovePaperWorkEstimate;